/* eslint-disable react/forbid-prop-types */
import React from 'react';
import Select from '@tds/core-select';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Button from '@tds/core-button';
import ButtonGroup from '@tds/core-button-group';

import { InputWrapper, DateWrapper, ButtonWrapper } from './css';
import { Box, Text } from '../../../design/css';
import TypeAhead from '../../../orderDetails/components/typeAhead';
import MultiSelect from './multiSelect';

import { isOrderFulfillmentTeam } from '../../../utils/request';

import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

const Filters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels
}) => {
  const {
    status,
    startDate,
    endDate,
    filterCriteria,
    channelId,
    province,
    createdBy,
    productInOrderFor
  } = filterState;
  const {
    completedAt,
    createdAt,
    filterByChannel,
    filterByDates,
    filterBySalesRep,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    salesRepNamePlaceholder,
    filtersDropdownTitle,
    filterByStatus,
    filterByProduct,
    statusPlaceholder,
    statusFilters,
    productPlaceholder,
    productFilters
  } = staticLabels;

  const { salesRepNames, channels } = data;

  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));

  const getButtonGroup = () => (
    <ButtonWrapper>
      <ButtonGroup
        name="filterDates"
        label=" "
        onChange={({ target: { value } }) =>
          updateFilters('filterCriteria', value)
        }
        value={filterCriteria}
      >
        <ButtonGroup.Item value="createdAt">{createdAt}</ButtonGroup.Item>
        <ButtonGroup.Item value="validatedAt">{completedAt}</ButtonGroup.Item>
      </ButtonGroup>
    </ButtonWrapper>
  );
  const onClickResetFilter = () => {
    onResetFilters();
    onApplyFilters(true);
  };

  const multiSelectFilters = [
    {
      label: 'Filter By Province:',
      name: 'province',
      options: [
        { label: 'Alberta', value: 'Alberta' },
        { label: 'British Columbia', value: 'British Columbia' },
        { label: 'Manitoba', value: 'Manitoba' },
        { label: 'Ontario', value: 'Ontario' },
        { label: 'Quebec', value: 'Québec' },
        { label: 'Saskatchewan', value: 'Saskatchewan' },
        { label: 'Atlantic', value: 'Atlantic' }
      ],
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    }
  ];

  const selectFilters = [
    {
      label: filterByProduct,
      placeholder: productPlaceholder,
      options: productFilters,
      value: productInOrderFor,
      onChange: ({ target: { value } }) =>
        updateFilters('productInOrderFor', value)
    },
    {
      label: filterByStatus,
      placeholder: statusPlaceholder,
      options: isOrderFulfillmentTeam ? statusFilters.slice(1) : statusFilters,
      value: status,
      onChange: ({ target: { value } }) => updateFilters('status', value)
    }
  ];
  const typeAheadFilters = [
    {
      label: filterBySalesRep,
      placeholder: salesRepNamePlaceholder,
      options: salesRepNames,
      selected: createdBy,
      onChange: value => updateFilters('createdBy', value)
    }
  ];

  const getMultiSelectFilters = listOfFilters => {
    return listOfFilters.map(({ label, options, name, value }) => {
      return (
        <div style={{ width: '400px', marginRight: '3rem' }}>
          <MultiSelect
            updateFilters={updateFilters}
            label={label}
            options={options}
            name={name}
            value={value}
          />
        </div>
      );
    });
  };

  const getSelectFilters = listOfFilters => {
    return listOfFilters.map(
      ({ label, placeholder, options, value, onChange, defaultValue }) => {
        return (
          options && (
            <div style={{ width: '400px', marginRight: '2rem' }}>
              <Select
                label={label}
                placeholder={placeholder}
                options={options}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
              />
            </div>
          )
        );
      }
    );
  };

  const getTypeAheadFilters = listOfFilters => {
    return listOfFilters.map(
      ({ label, placeholder, options, selected, onChange }) => {
        return (
          <div style={{ width: '400px', marginRight: '3rem' }}>
            <TypeAhead
              label={label}
              placeholder={placeholder}
              options={options}
              selected={selected}
              onChange={onChange}
            />
          </div>
        );
      }
    );
  };

  const getDateFilters = () => {
    return (
      <Box display="flex" width={30} mdWidth={100}>
        <Box>
          <Box>
            <Text>{filterByDates} </Text>
          </Box>
          <Box>{getButtonGroup()}</Box>
          <InputWrapper>
            <DateWrapper width="162px" mr={16}>
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={startDateLabel}
                selected={startDate}
                onChange={value => updateFilters('startDate', value)}
                maxDate={new Date()}
              />
            </DateWrapper>
            <DateWrapper width="186px">
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={endDateLabel}
                maxDate={new Date()}
                selected={endDate}
                onChange={value => updateFilters('endDate', value)}
              />
            </DateWrapper>
          </InputWrapper>
        </Box>
      </Box>
    );
  };

  return (
    <ExpandCollapse topDivider={false}>
      <ExpandCollapse.Panel id="filters" header={filtersDropdownTitle}>
        <div>
          <div>
            <div
              style={{
                display: 'flex',
                marginBottom: '1rem',
                flexWrap: 'wrap'
              }}
            >
              {getSelectFilters(selectFilters)}
              {getTypeAheadFilters(typeAheadFilters)}
            </div>
            <div
              style={{
                display: 'flex',
                marginBottom: '1rem',
                flexWrap: 'wrap'
              }}
            >
              {getMultiSelectFilters(multiSelectFilters)}
              {getDateFilters()}
            </div>
          </div>
        </div>
        <Box
          display="flex"
          // justifyContent="center"
          flexDirection="row"
          pt={64}
          mdJustifyContent="flex-start"
          mdWidth={100}
          mdPadding="16px 0"
          margin="0 auto"
        >
          <Button onClick={() => onApplyFilters(false)} variant="secondary">
            {buttonApply}
          </Button>
          <Box width="2"> </Box>
          <Button onClick={() => onClickResetFilter()}>{buttonReset}</Button>
        </Box>
      </ExpandCollapse.Panel>
    </ExpandCollapse>
  );
};

Filters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    status: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    filterCriteria: PropTypes.string,
    channelId: PropTypes.arrayOf(PropTypes.number),
    dealership: PropTypes.string,
    channelOrgCode: PropTypes.string,
    outletCode: PropTypes.string,
    createdBy: PropTypes.string,
    productInOrderFor: PropTypes.string,
    province: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  data: PropTypes.object.isRequired
};

export default Filters;
